// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3U4CU","largeAuthButton":"button_largeAuthButton__3lYWi","submitButton":"button_submitButton__Qp5Y8"};